import Box from '@mui/material/Box';
import { useEffect, type JSX, type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { LoadingSpinner } from '../LoadingSpinner';
import { useAuthStore } from '../../store/useAuthStore';

interface RequireAuthProps {
  children: ReactNode;
}

export function RequireAuth({ children }: RequireAuthProps): JSX.Element {
  const authState = useAuthStore((s) => s.authState);
  const openAuthModal = useAuthStore((s) => s.openAuthModal);

  useEffect(() => {
    if (authState === 'unauthenticated') {
      openAuthModal('login');
    }
  }, [authState, openAuthModal]);

  if (authState === 'loading') {
    return <LoadingSpinner fullScreen />;
  }
  if (authState === 'unauthenticated') {
    return <Navigate to="/" replace />;
  }
  return <Box>{children}</Box>;
}
